import { render, staticRenderFns } from "./chelianglayunzhanbi.vue?vue&type=template&id=30fa7892&scoped=true&"
import script from "./chelianglayunzhanbi.vue?vue&type=script&lang=js&"
export * from "./chelianglayunzhanbi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fa7892",
  null
  
)

export default component.exports